import React from "react";
import { profiles } from "../data/codingProfiles";

const About = () => {
  return (
    <section
      name="about"
      id="about"
      className="w-full md:h-screen bg-[#0a192f] text-gray-300 py-10"
    >
      <div className="flex flex-col justify-center items-center h-full mt-5">
        <div className="text-center my-5">
          <h3 className="text-4xl font-bold inline">
            About <span className="text-primary-color">Me</span>
          </h3>
          <p className="py-4">My Introduction</p>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p>
              Hey there! It’s a pleasure to make your acquaintance. Feel free to
              explore I’ve got plenty to share!😄
            </p>
          </div>
          <div>
            <p>
              “My passion for software engineering and problem-solving knows no
              bounds. With over 1000+ data structures and algorithms conquered
              across platforms like LeetCode and GFG, I thrive on the thrill of
              cracking tough challenges. And as a lifelong learner, I’m
              constantly upskilling to stay ahead in the ever-evolving world of
              technology.🧠🌟”
            </p>
          </div>
        </div>
        <div>
          <h1 className="text-2xl font-bold mt-16 px-4">
            My Coding Profiles - LeetCode & GFG
          </h1>
          <div className="flex gap-4 my-4 justify-center items-center">
            {profiles.map(({ id, icon, href, src }) => (
              <div
                key={id}
                className="bg-gray-400 rounded-full p-2 hover:bg-primary-color duration-200 hover:scale-110"
              >
                <ion-icon name="profile">
                  <a href={href} target="_blank" rel="noreferrer">
                    {/* <img src={src} alt="codingProfile"></img> */}
                    {icon ? (
                      icon
                    ) : (
                      <img
                        src={src}
                        alt="codingProfile"
                        className="h-10 w-10 rounded-full"
                      ></img>
                    )}
                  </a>
                </ion-icon>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
